import { useTheme } from 'styled-components';
import useClientDetailPageController from '../../1_application/client/clientDetailPageController';
import Column from '../core/components/box/column';
import Row from '../core/components/box/row';
import SizedBox from '../core/components/box/sizedBox';
import LXSelector from '../core/components/buttons/lxSelector';
import { XCenter } from '../core/components/center';
import { LXbody, LXh1, LXh4 } from '../core/texts/lxText';
import toIDString from '../../lib/util/dateFormatter';
import ClientInfoView from './components/clientInfoView';
import BoxContainer from '../core/components/box/boxContainer';
import { Client } from '../../2_domain/client/client';
import LXBack from '../core/components/buttons/lxBack';
import withAsync from '../../lib/asyncBounrdary/withAsync';
import LXSpinner from '../core/spinner/lx_spinner';
import LXError from '../core/error/lx_error';
import { useParams } from 'react-router-dom';
import Get from '../../lib/di/get';
import IClientRepository from '../../2_domain/client/iClientRepository';
import wrapPromise from '../../lib/asyncBounrdary/wrapPromise';
import OrderHistory from './components/orderHistory';

interface ClientDetailPageProps {
  client: Client;
}

const ClientDetailPage = (props: ClientDetailPageProps) => {
  const c = useClientDetailPageController(props.client);

  const theme = useTheme();

  const ControllHeader = (
    <Row justifyContent="space-between" alignItems="center">
      <LXBack></LXBack>
      <LXSelector<'Edit' | 'Delete'>
        kind={'secondary'}
        placeholder={theme.texts.manage}
        values={['Edit', 'Delete']}
        labels={[theme.texts.edit, theme.texts.delete]}
        onSelect={c.onManageHandler}
        dropdownItemWidth={120}
      ></LXSelector>
    </Row>
  );

  const ClientInformationHeader = (
    <Row justifyContent="space-between" alignItems="center">
      <LXh4>{theme.texts.information}</LXh4>
      <LXbody color={theme.colors.caption}>{`${
        theme.texts.dateOfRegistration
      }: ${toIDString(c.client.createdAt)}`}</LXbody>
    </Row>
  );

  return (
    <XCenter>
      <Column>
        <SizedBox height={80}></SizedBox>
        {ControllHeader}
        <SizedBox height={55}></SizedBox>
        <LXh1>{c.client.name}</LXh1>
        <SizedBox height={40}></SizedBox>
        {ClientInformationHeader}
        <SizedBox height={16}></SizedBox>
        <BoxContainer>
          <ClientInfoView client={c.client}></ClientInfoView>
        </BoxContainer>
        <SizedBox height={40}></SizedBox>
        <OrderHistory client={c.client} />
      </Column>
    </XCenter>
  );
};

const ClientDetailPageWrapper = () => {
  const { clientId } = useParams();
  const clientRepo = Get.find<IClientRepository>('IClientRepository');
  /// temp
  const client = wrapPromise<Id, Client>(
    clientRepo.getClientById,
    clientId as any,
    'ClientRepoKey'
  )();

  return <ClientDetailPage client={client}></ClientDetailPage>;
};

export default withAsync({
  child: ClientDetailPageWrapper,
  suspenseFallback: <LXSpinner></LXSpinner>,
  errorFallback: <LXError></LXError>,
});
